export default {
  leave: {},
  items: [],
  pagination: {},
  isBusy: false,
};
